import styles from "./Oppsummering.module.less";
import Translated from "../infrastructure/translation/Translated";
import { Heading } from "@digipost/dds-heading-react";
import { TranslationKey } from "../infrastructure/translation/translator";

export interface SummaryPoint {
  headerKey: TranslationKey;
  values: (string | undefined | React.ReactElement)[];
}

export function OppsummeringBody({
  summaryPoints,
  extraClassName,
}: {
  summaryPoints: SummaryPoint[];
  extraClassName?: string;
}) {
  return (
    <div className={`${styles.oppsummering} ${extraClassName || ""}`}>
      {summaryPoints.map((point, index) => (
        <article key={index}>
          <Heading level={2} size={"xsmall"} className={styles.miniheader}>
            <Translated textKey={point.headerKey} />
          </Heading>
          {point.values.map((value, valueIndex) => {
            if (typeof value === "string") {
              return <span key={valueIndex}>{value}</span>;
            } else if (typeof value === "object") {
              return value;
            }
            return <></>;
          })}
        </article>
      ))}
    </div>
  );
}
